var exports = {
  "k": "xfd349460--8648cc--container",
};

module.exports = exports;
